import React, { useState, useEffect } from "react";

import { ContactForm } from "../../components/contactForm/ContactForm";
import { TileList } from "../../components/tileList/TileList";

export const ContactsPage = ({contacts, addContact}) => {
  /*
  Define state variables for 
  contact info and duplicate check
  */
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [isDuplicate, setIsDuplicate] = useState(false);
  
  /*
  Using hooks, check for contact name in the 
  contacts array variable in props
  */
  useEffect(() => {
    const nameIsDuplicate = () => {
      const found = contacts.find(contact => contact.name === name);
      if(found !== undefined){
        return true
      } 
      return false
    };

    if(nameIsDuplicate()){
      setIsDuplicate(true)
    } else{
      setIsDuplicate(false)
    }
  }, [contacts, name]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    /*
    Add contact info and clear data
    if the contact name is not a duplicate
    */
   if(!isDuplicate) {
    addContact(name, phone, email);
    setName('');
    setPhone('');
    setEmail('');
   };
   
  };

  return (
    <div>
      <section>
        <h2 className="heading">
          Add Contact
          {isDuplicate ? "- Name Already Exists" : ""}
        </h2> 
        <ContactForm 
        name={name}
        setName={setName}
        phone={phone}
        setPhone={setPhone}
        email={email}
        setEmail={setEmail}
        handleSubmit={handleSubmit}
        />
      </section>
      <hr />
      <section>
        <h2 className="heading">Contacts</h2>
        <TileList tiles={contacts}/>
      </section>
    </div>
  );
};
